module.exports = __webpack_public_path__ + "img/emergency-expense-icon.580fc23c.svg";